import { FC } from 'react';

interface Props {
  size?: number | string;
  inline?: boolean;
}

export const CircularProgress: FC<Props> = ({ size, inline }) => {
  const strokeWidth = 4;
  const circleStyle = { animation: 'spinning 1.4s linear infinite' };

  return (
    <svg
      style={{ padding: 4, display: inline ? 'inline' : 'block' }}
      fill="none"
      viewBox="0 0 66 66"
      width={size ?? 50}
    >
      <circle
        cx="33"
        cy="33"
        fill="none"
        r="28"
        stroke="rgba(0,0,0,0.1)"
        strokeWidth={strokeWidth}
      />
      <circle
        cx="33"
        cy="33"
        fill="none"
        r="28"
        stroke="currentColor"
        strokeDasharray="40, 134"
        strokeDashoffset="325"
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        style={circleStyle}
      />
    </svg>
  );
};
